export default __webpack_public_path__ + "static/ds-zeroheight-lapierre-product-1d418e6f630659a6050e76429f823829.png";